import React from "react";
import { useNavigate } from "react-router";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmailIcon from '@mui/icons-material/Email';

const cssIconButton = {
  display: { md: 'flex', lg: 'none' },
  minWidth: '45px',
  width: '45px',
  height: '45px',
  borderRadius: '4px',
  padding: 0,
  boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px',
};

export default function DocumentosToolbar(props) {
  const navigate = useNavigate();

  const isSelected = (props.selected !== '');
  return (
    <Toolbar
      position="static"
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifycontent: 'flex-start',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography
          variant="h6"
          id="tableTitle"
          component="div"
          sx={{
            marginRight: '10px',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          Usuários
        </Typography>

        <TextField
            fullWidth
            id={`search-input`}
            sx={{ m: 1, minWidth: '300px' }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            onChange={props.handleSearch}
          />
      </Box>

      <Box
        sx={{
          flex: 2,
          justifyContent: 'flex-end',
          alignItems: 'right',
          gap: 2,
          ml: 'auto',
          display: { xs: 'none', sm: 'flex' },
        }}
      >
        <Stack direction="row" spacing={1} justifycontent="flex-end">

          <Tooltip title="Voltar">
            <Button
              sx={{
                minWidth: '45px',
                width: '45px',
                height: '45px',
                borderRadius: '4px',
                padding: 0,
                boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px',
              }}
              variant="outlined"
              size="large"
              onClick={()=>{
                navigate('/');
              }}>
              <ArrowBackIcon />
            </Button>
          </Tooltip>

          {isSelected ? (
            <>
              <Tooltip title="Excluir">
                <Button
                  sx={{
                    height: '45px',
                    display: { md: 'none', lg: 'flex' }
                  }}
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  size="large"
                  color="error"
                  onClick={()=>{props.handleOpenDeleteDialog()}}>
                  Excluir
                </Button>
                <Button
                  sx={cssIconButton}
                  variant="contained"
                  size="large"
                  color="error"
                  onClick={()=>{props.handleOpenDeleteDialog()}}>
                  <DeleteIcon />
                </Button>
              </Tooltip>

              {
                props.situacaoNome === 'Ativo' ? (
                  <Tooltip title="Desativar">
                    <Button
                      sx={{
                        height: '45px',
                        display: { md: 'none', lg: 'flex' }
                      }}
                      variant="contained"
                      startIcon={<PersonOffIcon />}
                      size="large"
                      color="warning"
                      onClick={()=>{props.handleOpenDisableDialog()}}>
                      Desativar
                    </Button>
                    <Button
                      sx={cssIconButton}
                      variant="contained"
                      size="large"
                      color="warning"
                      onClick={()=>{props.handleOpenDisableDialog()}}>
                      <PersonOffIcon />
                    </Button>
                  </Tooltip>
                ) : (
                  <Tooltip title="Ativar">
                    <Button
                      sx={{
                        height: '45px',
                        display: { md: 'none', lg: 'flex' }
                      }}
                      variant="contained"
                      startIcon={<PersonIcon />}
                      size="large"
                      color="success"
                      onClick={()=>{
                        props.handleAtivarUsuario(()=>{});
                      }}>
                      Ativar
                    </Button>
                    <Button
                      sx={cssIconButton}
                      variant="contained"
                      size="large"
                      color="success"
                      onClick={()=>{
                        props.handleAtivarUsuario(()=>{});
                      }}>
                      <PersonIcon />
                    </Button>
                  </Tooltip>
                )
              }

              <Tooltip title="Reenviar e-mail">
                <Button
                  sx={{
                    height: '45px',
                    display: { md: 'none', lg: 'flex' }
                  }}
                  variant="contained"
                  startIcon={<EmailIcon />}
                  size="large"
                  onClick={props.handleReenviarEmail}>
                  Reenviar
                </Button>
                <Button
                  sx={cssIconButton}
                  variant="contained"
                  size="large"
                  onClick={props.handleReenviarEmail}>
                  <EmailIcon />
                </Button>
              </Tooltip>

              <Tooltip title="Editar">
                <Button
                  sx={{
                    height: '45px',
                    display: { md: 'none', lg: 'flex' },
                  }}
                  variant="contained"
                  startIcon={<EditIcon />}
                  size="large"
                  onClick={props.handleEditarUsuario}>
                  Editar
                </Button>
                <Button
                  sx={cssIconButton}
                  variant="contained"
                  size="large"
                  onClick={props.handleEditarUsuario}>
                  <EditIcon />
                </Button>
              </Tooltip>

            </>
          ) : (<></>)}

          <Tooltip title="Novo">
            <Button
              variant="contained"
              startIcon={<PersonAddIcon />}
              size="large"
              color="success"
              onClick={()=>{
                navigate('/cadastrar-usuario');
              }}>
              Novo
            </Button>
          </Tooltip>
        </Stack>
      </Box>

    </Toolbar>
  );
}
